import React, { Component } from 'react';

class TohokuTop extends Component {
  render() {
    return (
      <div className="Tohoku-top pref">
        <div>青森</div>
      </div>
    );
  }
}

class TohokuMidTop extends Component {
  render() {
    return (
      <div className="Tohoku-mid-top pref">
        <div>秋田</div>
        <div>岩手</div>
      </div>
    );
  }
}
class TohokuMidBot extends Component {
  render() {
    return (
      <div className="Tohoku-mid-bot pref">
        <div>山形</div>
        <div>宮城</div>
      </div>
    );
  }
}

class TohokuBot extends Component {
  render() {
    return (
      <div className="Tohoku-bot pref">
        <div>福島</div>
      </div>
    );
  }
}

class Tohoku extends Component {

  render() {

    return (
      <div className="Tohoku">
        <TohokuTop />
        <TohokuMidTop />
        <TohokuMidBot />
        <TohokuBot />
      </div>
    );
  }

}

export default Tohoku;
